import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Link} from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import {Empty} from 'antd'

import style from './notFound.sass'

@inject('store') @observer
class NotFound extends Component {
  componentDidMount() {
    this.props.store.notFound = false
  }
  goBack = () => {
    this.props.history.goBack()
  }
  render() {
    return(
      <Empty
        description={' '}
        styleName='wrapper'
      >
        <DocumentTitle title='Page not found'/>
        <h2>This page doesn&apos;t exist</h2>
        <span>You can <a onClick={this.goBack}>return</a> to the previous page or go to <Link to='/manager'>Manager</Link></span>
      </Empty>
    )
  }
}

export default NotFound
